export const ContactEmail: string = 'energy@lcp.com';
export const SparkHelpdeskEmail: string = 'spark.helpdesk@lcp.com';
